import Vue from "@/helper/initVue";

import SearchComponent from "@/components/header/SearchComponent.vue";

const search = new Vue({
  render: (h) => h(SearchComponent),
});

search.$mount("#search");
